import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { unitStats } from '../../../stats';

export const garrisonReducer = (scratch: StatsSnapshot) => {
  // const garrison = scratch.generators.garrison;
  const stats = unitStats.garrison;

  const generatedWarriors = stats.unitsGeneration ?? 0;

  scratch.generators.warrior.owned += generatedWarriors;

  return;
};
